var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextepColorNoText = function SvgNextepColorNoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 6 39.89 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.791 42.755a3.4 3.4 0 1 1-3.4-3.394 3.395 3.395 0 0 1 3.4 3.394",
    fill: "#5c688e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.078 42.756a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4M23.363 42.756a3.4 3.4 0 1 1-3.4-3.4 3.394 3.394 0 0 1 3.4 3.4M31.644 42.756a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4M39.932 42.756a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4",
    fill: "#bfc3c5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.791 34.472a3.4 3.4 0 1 1-3.4-3.393 3.4 3.4 0 0 1 3.4 3.393M15.078 34.472a3.4 3.4 0 1 1-3.4-3.393 3.4 3.4 0 0 1 3.4 3.393M23.363 34.472a3.4 3.4 0 1 1-3.4-3.393 3.4 3.4 0 0 1 3.4 3.393",
    fill: "#5c688e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.644 34.472a3.4 3.4 0 1 1-3.4-3.393 3.4 3.4 0 0 1 3.4 3.393M39.932 34.472a3.4 3.4 0 1 1-3.4-3.393 3.4 3.4 0 0 1 3.4 3.393",
    fill: "#bfc3c5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.363 26.19a3.4 3.4 0 1 1-3.4-3.4 3.395 3.395 0 0 1 3.4 3.4",
    fill: "#5c688e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.644 26.19a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4M39.932 26.19a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4",
    fill: "#bfc3c5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.363 17.904a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4M31.644 17.904a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4M39.932 17.904a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4M39.932 9.621a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4",
    fill: "#5c688e"
  })));
};
export default SvgNextepColorNoText;